import { z } from 'zod';

export const EXPORT_MAP_ID_PATTERN = /^(?:guest:[a-f0-9-]{36}|saved:[A-Za-z0-9_-]{1,128})$/;
export const exportEvidenceSchema = z.object({
  version: z.literal(1),
  map_id: z.string().regex(EXPORT_MAP_ID_PATTERN),
  content_hash: z.string().regex(/^[a-f0-9]{64}$/),
  settings_hash: z.string().regex(/^[a-f0-9]{64}$/),
});
export type ExportEvidence = z.infer<typeof exportEvidenceSchema>;

export function compareExportEvidence(a: ExportEvidence | null, b: ExportEvidence | null) {
  if (!a || !b || a.version !== b.version) return 'unknown';
  if (a.map_id !== b.map_id) return 'different_maps';
  if (a.content_hash !== b.content_hash) return 'same_map_edited';
  if (a.settings_hash !== b.settings_hash) return 'same_map_different_settings';
  return 'same_map_same_settings';
}

export function parseExportEvidenceJson(value: string | undefined): ExportEvidence | null {
  if (!value) return null;
  try { return exportEvidenceSchema.safeParse(JSON.parse(value)).data ?? null; }
  catch { return null; }
}

export function serializeExportEvidence(evidence: ExportEvidence | null | undefined): string | null {
  return evidence ? JSON.stringify(evidence) : null;
}
